import { useCallback } from "react";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";

import {
  convertTimeToTimeZone,
  displayTime,
} from "@common/utils/localTime.utils";

export const useDateFormatter = () => {
  const [user] = useAuthenticatedUser();
  const getRealtimeDate = useCallback(() => {
    const dateTime = new Date();
    const dayFormatDescription: Intl.DateTimeFormatOptions = {
      weekday: "long",
    };
    const dateFormatDescription: Intl.DateTimeFormatOptions = {
      month: "long",
      day: "2-digit",
    };

    const dayConverted = convertTimeToTimeZone(
      dateTime,
      dayFormatDescription,
      user?.details.timeZone
    );

    const dateConverted = convertTimeToTimeZone(
      dateTime,
      dateFormatDescription,
      user?.details.timeZone
    );

    const timeConverted = displayTime(dateTime.getTime());

    const dateData: RealTimeDateProps = {
      data: {
        day: dayConverted,
        date: dateConverted,
        time: timeConverted,
      },
    };

    return dateData;
  }, [user?.details.timeZone]);

  return { getRealtimeDate };
};
